import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button, Input } from '../../../../components/base';
import ContentTable from '../../../../components/ContentTable/ContentTable.component';
import { FINANCE_ADJUSTMENT_JOURNAL_TABLE_FIELDS } from '../../../../constants/finance/bookeeping.constant';

export default class AdjustmentJournal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        value: {},
        error: {},
      },
    };
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._onClickEdit = this._onClickEdit.bind(this);
  }

  _onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/keuangan/pembukuan/kelola-jurnal-penyesuaian', { isEdit: false });
  }

  _onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/keuangan/pembukuan/kelola-jurnal-penyesuaian', { data: { id: val.id }, isEdit: true });
  }

  _onFormChange(event) {
    const {
      name,
      value,
    } = event.target;
    this.setState(prevState => ({
      form: {
        value: {
          ...prevState.form.value,
          [name]: value,
        },
        error: {
          ...prevState.form.error,
          [name]: '',
        },
      },
    }));
  }

  render() {
    const { form } = this.state;
    const { handleGetAdjustmentJournal } = this.props;
    return (
      <div className="adjustment-journal">
        <div className="adjustment-journal__add-button">
          <Button
            title="Tambah Jurnal Penyesuaian"
            onClick={this._onClickAdd}
          />
        </div>
        <div className="adjustment-journal__date">
          <Input
            type="date"
            name="date"
            value={form.value.date}
            onChange={this._onFormChange}
          />
        </div>
        <div className="adjustment-journal__content">
          <ContentTable
            onSearchContent={handleGetAdjustmentJournal}
            tableFields={FINANCE_ADJUSTMENT_JOURNAL_TABLE_FIELDS}
            onClickEdit={this._onClickEdit}
            showDelete={false}
            customThead={(
              <thead>
                <tr>
                  <th rowSpan={2}>No</th>
                  <th rowSpan={2}>Tanggal</th>
                  <th colSpan={2}>Akun</th>
                  <th rowSpan={2}>Keterangan</th>
                  <th rowSpan={2}>Debet</th>
                  <th rowSpan={2}>Kredit</th>
                  <th rowSpan={2}>&nbsp;</th>
                </tr>
                <tr>
                  <th>Kode</th>
                  <th>Nama</th>
                </tr>
              </thead>
            )}
          />
        </div>
      </div>
    );
  }
}
AdjustmentJournal.propTypes = {
  handleGetAdjustmentJournal: PropTypes.func,
  history: PropTypes.object.isRequired,
};
AdjustmentJournal.defaultProps = {
  handleGetAdjustmentJournal: noop,
};
